var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c("el-tab-pane", { attrs: { label: "待审核", name: "auditing" } }),
          _c(
            "el-tab-pane",
            { attrs: { label: "零管助手", name: "bairun-retail-assistant" } },
            [
              _c("el-alert", {
                staticClass: "bairun-margin-b",
                attrs: {
                  title: "白名单微信用户可免密登录【零管助手小程序】",
                  type: "info"
                }
              })
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "微信app", name: "bairunpublic" } },
            [
              _c("el-alert", {
                staticClass: "bairun-margin-b",
                attrs: {
                  title:
                    "白名单微信用户可在微信中免密登录【管理后台】，登录链接为：" +
                    _vm.path +
                    "/base/wxauth/code?appSource=bairunpublic",
                  type: "info"
                }
              })
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "管理后台", name: "bairunadmin" } },
            [
              _c("el-alert", {
                staticClass: "bairun-margin-b",
                attrs: {
                  title: "白名单微信用户可微信扫码登录【管理后台】",
                  type: "info"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            { attrs: { inline: true, model: _vm.searchInfo } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "用户昵称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.nickname,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "nickname", $$v)
                      },
                      expression: "searchInfo.nickname"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "姓名" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.userName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "userName", $$v)
                      },
                      expression: "searchInfo.userName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("查询")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, stripe: "", border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { label: "用户头像", prop: "goodsImg", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("img", {
                      staticStyle: { width: "50px", height: "50px" },
                      attrs: { src: scope.row.avatar }
                    })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", { attrs: { prop: "userName", label: "姓名" } }),
          _c("el-table-column", { attrs: { prop: "nickname", label: "昵称" } }),
          _c("el-table-column", {
            attrs: { prop: "appid", label: "appid", width: "300" }
          }),
          _c("el-table-column", {
            attrs: { prop: "openid", label: "openid", width: "300" }
          }),
          _c("el-table-column", {
            attrs: { prop: "appSource", label: "所属平台", width: "200" }
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.auditStatus ? "操作日期" : "审核日期",
              prop: "UpdatedAt",
              width: "200"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.UpdatedAt)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "审核状态", prop: "UpdatedAt" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.auditStatus == 1
                      ? _c("el-tag", [_vm._v("待审核")])
                      : _vm._e(),
                    scope.row.auditStatus == 2
                      ? _c("el-tag", { attrs: { type: "success" } }, [
                          _vm._v("通过")
                        ])
                      : _vm._e(),
                    scope.row.auditStatus == 3
                      ? _c("el-tag", { attrs: { type: "danger" } }, [
                          _vm._v("不通过")
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", prop: "UpdatedAt", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.auditStatus != 2
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: {
                              slot: "reference",
                              size: "small",
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.agree(scope.row)
                              }
                            },
                            slot: "reference"
                          },
                          [_vm._v("审核")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 1
                      ? _c(
                          "el-popconfirm",
                          {
                            staticStyle: { "margin-left": "10px" },
                            attrs: { title: "请问确定不通过审核吗？" },
                            on: {
                              confirm: function($event) {
                                return _vm.disagree(scope.row)
                              }
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "table-button",
                                attrs: {
                                  slot: "reference",
                                  size: "small",
                                  type: "danger"
                                },
                                slot: "reference"
                              },
                              [_vm._v("拒绝")]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 2
                      ? _c(
                          "el-popconfirm",
                          {
                            attrs: { title: "请问删除该用户吗？" },
                            on: {
                              confirm: function($event) {
                                return _vm.cancel(scope.row)
                              }
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "table-button",
                                attrs: {
                                  slot: "reference",
                                  size: "small",
                                  type: "danger"
                                },
                                slot: "reference"
                              },
                              [_vm._v("删除")]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "用户信息", visible: _vm.dialogFormVisible },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "姓名" } },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.form.userName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "userName", $$v)
                      },
                      expression: "form.userName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogFormVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.agreeClick } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }